import React from "react";
import { WithPermissions } from "react-admin";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import moment from "moment";
import { styles } from "./ExportarPesajeStyle";
import "date-fns";
import format from "date-fns/format";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import "./ExportarPesaje.module.css";
import { getMonthName } from "../../utils.js";
import "moment/locale/es";

import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";

const saveAs = require("file-saver");

/**
 * Component: CSV weighing export
 */

moment.locale("es");

/** Set date global variables */

let lastMonth = new Date(new Date().setMonth(new Date().getMonth() - 1));
let lastMonthNumber = new Date(lastMonth).getMonth();
let lastMonthName = getMonthName(lastMonthNumber);
let lastMonthYear = new Date(lastMonth).getFullYear();

let lastMonthFirstDay = new Date(lastMonthYear, lastMonthNumber, 1);
let lastMonthLastDay = new Date(lastMonthYear, lastMonthNumber, 32);

/** Set Material-ui-picker dateformat */

class LocalizedUtils extends DateFnsUtils {
  getDatePickerHeaderText(date) {
    return format(date, "dd/MM/yyyy", { locale: this.locale });
  }
}

export class ExportarPesajeCsv extends React.Component {
  constructor(permissions, props) {
    super(props);

    /** Set initial date private variables */

    let dateFrom = new Date(
      new Date().setDate(new Date().getDate() - 7)
    ).setHours(0, 0, 0, 0);
    let dateTo = new Date().setHours(23, 59, 59, 999);

    this.state = {
      open: true,
      dataExport: [],
      dataCustomExist: false,
      pesajesDateFrom: dateFrom,
      pesajesDateTo: dateTo,
      csv: { titulo: "Ingreso de materiales", url: "pesajes" }
    };
  }

  handelCsv = event => {
    this.setState({
      csv: {
        titulo: event.target.name,
        url: event.target.value
      }
    });
  };

  handleDateFromChange = date => {
    this.setState({ pesajesDateFrom: new Date(date) });
  };

  handleDateToChange = date => {
    this.setState({ pesajesDateTo: new Date(date) });
  };

  onClickExportPesajes = (e, from, to) => {
    const DateFrom = new Date(from).toISOString();
    const DateTo = new Date(to).toISOString();

    // const link =
    //   process.env.REACT_APP_API_URL + '/' + this.state.csv.url +
    //   '?&fecha[$gte]=' + DateFrom +
    //   '&fecha[$lt]=' + DateTo +
    //   '&$sort[fecha]=1';
    //   //'&filter={"etapa":"E16"}';
    // console.log(link);
    // window.location.href = link

    const jwt = window.localStorage.getItem("feathers-jwt");
    fetch(
      process.env.REACT_APP_API_URL +
        "/" +
        this.state.csv.url +
        ".csv" +
        "?&fecha[$gte]=" +
        DateFrom +
        "&fecha[$lt]=" +
        DateTo +
        "&$sort[fecha]=1",
      {
        method: "get",
        headers: {
          Authorization: "Bearer " + jwt,
          "Content-Type": "text/csv",
          Accept: "text/csv"
        },
        responseType: "blob"
      }
    )
      .then(response => response.blob())
      .then(blob => {
        const filename =
          this.state.csv.url +
          "-" +
          moment(from).format("DD-MM-YYYY") +
          "-" +
          moment(to).format("DD-MM-YYYY") +
          ".csv";
        saveAs(blob, filename);
      });
    //pesajes.csv?fecha[$gte]=2019-05-02T00:00:00.000Z&fecha[$lt]=2019-05-20T00:00:00.000Z
  };
  render() {
    const Selector = props => (
      <Grid item xs={12}>
        <Paper style={styles.paperIcon}>
          <Grid
            container
            spacing={0}
            justify="flex-start"
            alignItems="flex-start"
          >
            <Grid item xs={4} md={4}>
              <CloudDownloadIcon className="paper2-icon" />
            </Grid>
            <Grid item xs={8} md={8}>
              <Typography component="h3" style={styles.titlePaper}>
                Seleccionar Descarga
              </Typography>
              <Select
                value={this.state.csv.url}
                onChange={this.handelCsv}
                input={<Input name="csv" id="csv-helper" />}
                style={styles.selectBig}
              >
                <MenuItem key="sel1" value="pesajes">
                  Ingreso de materiales
                </MenuItem>
                <MenuItem key="sel2" value="terceros">
                  Ingreso de Terceros
                </MenuItem>
                <MenuItem key="sel3" value="ingreso-grandes-generadores">
                  Ingreso de grandes generadores
                </MenuItem>
                <MenuItem key="sel4" value="pesaje-material">
                  Producción
                </MenuItem>
                <MenuItem key="sel5" value="remitos">
                  Salidas
                </MenuItem>
              </Select>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    );

    return (
      <Grid root>
        <Grid container spacing={0} justify="center" style={styles.max800}>
          <WithPermissions
            render={({ permissions }) =>
              permissions === "admin" ? <Selector {...this.props} /> : null
            }
          />
          <Grid item xs={12} md={6}>
            <Paper style={styles.paperIcon}>
              <Typography component="h3" style={styles.titlePaper}>
                {lastMonthName} de {lastMonthYear}
              </Typography>

              <Button
                id="export-current-date"
                variant="contained"
                className="primary"
                onClick={e => {
                  this.onClickExportPesajes(
                    e,
                    lastMonthFirstDay,
                    lastMonthLastDay
                  );
                }}
              >
                Descargar
              </Button>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper style={styles.paperIcon}>
              <Typography component="h3" style={styles.titlePaper}>
                Seleccionar fechas
              </Typography>
              <div>
                <MuiPickersUtilsProvider
                  moment={moment}
                  utils={LocalizedUtils}
                  locale={esLocale}
                >
                  <DatePicker
                    name="desde"
                    label="Desde"
                    format="dd/MM/yyyy"
                    value={this.state.pesajesDateFrom}
                    onChange={this.handleDateFromChange}
                  />
                </MuiPickersUtilsProvider>
              </div>
              <div>
                <MuiPickersUtilsProvider
                  moment={moment}
                  utils={LocalizedUtils}
                  locale={esLocale}
                >
                  <DatePicker
                    name="hasta"
                    label="Hasta"
                    format="dd/MM/yyyy"
                    value={this.state.pesajesDateTo}
                    onChange={this.handleDateToChange}
                  />
                </MuiPickersUtilsProvider>
              </div>
              <div>
                <Button
                  id="export-custom-date"
                  variant="contained"
                  className="primary"
                  onClick={e => {
                    this.onClickExportPesajes(
                      e,
                      this.state.pesajesDateFrom,
                      this.state.pesajesDateTo
                    );
                  }}
                >
                  Descargar
                </Button>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ExportarPesajeCsv/ExportarPesajeCsv.js